export class Division {
    id = -1;
    description = '';

    deserialize(data: any) {
        this.id = data.Code ?? -1;
        this.description = data.Description ?? '';
        return this;
    }

    static Sort(a1: Division, a2: Division) {
        return a1.description.localeCompare(a2.description);
    }
}
